"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.PhoneNumberField = void 0;
var _react = _interopRequireWildcard(require("react"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _SelectInput = require("../../Form/SelectInput/SelectInput");
var _CheckboxInput = require("../../Form/CheckboxInput/CheckboxInput");
var _NumberInput = require("../../Form/NumberInput/NumberInput");
var _getPhoneCodes = _interopRequireDefault(require("./getPhoneCodes"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/forbid-prop-types */

function isOcSmsEnabled(showOcSms, type) {
  return showOcSms && type === 'Mobile';
}
const PhoneNumberField = props => {
  const {
    data,
    config,
    labels
  } = props;
  const {
    focusName,
    touched,
    handleBlur = () => {},
    onChange = () => {},
    showOcSms,
    showPreferred,
    disablePreferred,
    phoneTypes,
    smsInformation,
    disabled,
    errors,
    // labels start
    phoneLabel,
    phonePromptText,
    countryLabel,
    countryPromptText,
    nationalNumberLabel,
    preferredLabel,
    ocSmsLabel,
    noOptionsMessage,
    phoneNumberLength,
    useStrictMode
    // labels end
  } = config;
  const {
    type,
    nationalNumber,
    country,
    isPrimary,
    ocSms = false,
    id
  } = data;

  // sets default values of inputs and displays extra information when mobile type is set.
  const [defaultTypeValue] = (0, _react.useState)(type);
  const [defaultCountry] = (0, _react.useState)(country);

  // if adding a new number, set default country to user country
  const isTypeError = !!(touched != null && touched.type && errors != null && errors.type);
  const isCountryError = !!(touched != null && touched.country && errors != null && errors.country);
  const isNationalNumberError = !!(touched != null && touched.nationalNumber && errors != null && errors.nationalNumber);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "ccl-e-phone-number-field",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "ccl-e-phone-number-field__row",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "ccl-e-phone-number-field__row__cell-combination",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "ccl-e-phone-number-field__row__cell-combination__cell",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectInput.SelectInput, {
            "data-nw-error-field": isTypeError && 'type' || undefined,
            disabled: disabled,
            setFocus: focusName === 'type',
            error: isTypeError,
            errorMsg: errors == null ? void 0 : errors.type,
            onChange: (name, value) => {
              onChange(name, value);
            },
            onBlur: handleBlur,
            dataList: phoneTypes,
            defaultValue: defaultTypeValue,
            label: labels[phoneLabel],
            name: "type",
            id: `type-${id}`,
            promptText: labels[phonePromptText],
            noOptionsMessage: labels[noOptionsMessage]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "ccl-e-phone-number-field__row__cell-combination__cell",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectInput.SelectInput, {
            "data-nw-error-field": isCountryError && 'country' || undefined,
            disabled: disabled,
            dataList: (0, _getPhoneCodes.default)(),
            defaultValue: defaultCountry,
            setFocus: focusName === 'country',
            error: isCountryError,
            errorMsg: errors == null ? void 0 : errors.country,
            onChange: onChange,
            onBlur: handleBlur,
            flagIcon: true,
            isSearchable: true,
            label: labels[countryLabel],
            name: "country",
            id: `country-${id}`,
            promptText: countryPromptText,
            noOptionsMessage: noOptionsMessage
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "ccl-e-phone-number-field__row__cell",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_NumberInput.NumberInput, {
          "data-nw-error-field": isNationalNumberError && 'nationalNumber' || undefined,
          disabled: disabled,
          setFocus: focusName === 'nationalNumber',
          error: isNationalNumberError,
          errorMsg: errors == null ? void 0 : errors.nationalNumber,
          onBlur: e => {
            var _e$target;
            return handleBlur(e == null || (_e$target = e.target) == null ? void 0 : _e$target.name);
          },
          label: labels[nationalNumberLabel],
          name: "nationalNumber",
          id: `nationalNumber-${id}`,
          onChange: e => {
            var _e$target2, _e$target3;
            return onChange(e == null || (_e$target2 = e.target) == null ? void 0 : _e$target2.name, e == null || (_e$target3 = e.target) == null ? void 0 : _e$target3.value);
          },
          value: nationalNumber,
          requiredLength: phoneNumberLength,
          isStrict: useStrictMode
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "ccl-e-phone-number-field__row",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "ccl-e-phone-number-field__row__cell",
        children: isOcSmsEnabled(showOcSms, type) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "ccl-e-phone-number-field__row__cell__text"
          // eslint-disable-next-line react/no-danger
          ,
          dangerouslySetInnerHTML: {
            __html: _dompurify.default.sanitize(labels[smsInformation])
          }
        }) : undefined
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "ccl-e-phone-number-field__row__cell",
        children: [showPreferred && type !== 'Fax' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckboxInput.CheckboxInput, {
          disabled: disabled || disablePreferred,
          setFocus: focusName === 'isPrimary',
          error: (touched == null ? void 0 : touched.isPrimary) && (errors == null ? void 0 : errors.isPrimary),
          errorMsg: errors == null ? void 0 : errors.isPrimary,
          onBlur: handleBlur,
          label: labels[preferredLabel],
          name: "isPrimary",
          onChange: e => {
            var _e$target4, _e$target5;
            return onChange(e == null || (_e$target4 = e.target) == null ? void 0 : _e$target4.name, e == null || (_e$target5 = e.target) == null ? void 0 : _e$target5.checked);
          },
          checked: isPrimary
        }) : undefined, isOcSmsEnabled(showOcSms, type) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckboxInput.CheckboxInput, {
          disabled: disabled,
          setFocus: focusName === 'ocSms',
          error: (touched == null ? void 0 : touched.ocSms) && (errors == null ? void 0 : errors.ocSms),
          errorMsg: errors == null ? void 0 : errors.ocSms,
          onBlur: handleBlur,
          label: labels[ocSmsLabel],
          name: "ocSms",
          onChange: e => {
            var _e$target6, _e$target7;
            return onChange(e == null || (_e$target6 = e.target) == null ? void 0 : _e$target6.name, e == null || (_e$target7 = e.target) == null ? void 0 : _e$target7.checked);
          },
          checked: !(ocSms === 'Withdrawn' || ocSms === null) // false when withdrawn or null
        }) : undefined]
      })]
    })]
  });
};
exports.PhoneNumberField = PhoneNumberField;
PhoneNumberField.defaultProps = {
  data: {},
  config: {}
};